module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1124.24b7c59e.png";